import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { format } from 'date-fns/format';

import { Session, SessionUtils } from '@optical/types';
import { getLongDateFormat } from '@optical/utils';
import { convertDuration } from '@optical/utils';

@Pipe({
  name: 'sessionTime',
})
export class SessionTimePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(session: Session, includeDuration = true): string {
    return [
      format(session.start, getLongDateFormat('LT')),
      ...(typeof session.end === 'undefined'
        ? [`(${this.translateService.instant('app.uploading')})`]
        : [
            '-',
            format(session.end, getLongDateFormat('LT')),
            includeDuration
              ? '(' +
                convertDuration(SessionUtils.getDuration(session), {
                  withSeconds: false,
                  withSymbol: true,
                }) +
                ')'
              : undefined,
          ]),
    ].join(' ');
  }
}
